import {
  DASHED_LINE_PREFIX,
  HIGHLIGHT_LAYER_PREFIX,
  LABEL_LAYER_PREFIX,
  POLYGON_OUTLINE_LAYER_PREFIX,
  POLYGON_FILL_LAYER_PREFIX,
  RASTER_LAYER_PREFIX,
  CIRCLE_LAYER_PREFIX,
} from '../../constants';

export const getDashedLineMapboxLayerId = (mapboxLayerId) => DASHED_LINE_PREFIX + mapboxLayerId;

export const getPolygonOutlineMapboxLayerId = (mapboxLayerId) =>
  `${POLYGON_OUTLINE_LAYER_PREFIX}${mapboxLayerId}`;

export const getLabelMapboxLayerId = (mapboxLayerId) => `${LABEL_LAYER_PREFIX}${mapboxLayerId}`;

export const getRasterMapboxLayerId = (mapboxLayerId) => `${RASTER_LAYER_PREFIX}${mapboxLayerId}`;

export const getCircleMapboxLayerId = (mapboxLayerId) => `${CIRCLE_LAYER_PREFIX}${mapboxLayerId}`;

export const getHighlightMapboxLayerId = (mapboxLayerId, isHighlightFill, isCircleLayer) => {
  // for polygons, only the borders are highlighted
  if (mapboxLayerId.endsWith('polygon')) {
    // adds the ability to add a highlight fill layer to a highlight if fillColor is set on the feature being highlighted
    if (isHighlightFill) {
      return `${HIGHLIGHT_LAYER_PREFIX}${POLYGON_FILL_LAYER_PREFIX}${mapboxLayerId}`;
    }
    const polygonOutlineLayerId = getPolygonOutlineMapboxLayerId(mapboxLayerId);

    return `${HIGHLIGHT_LAYER_PREFIX}${polygonOutlineLayerId}`;
  }

  const layerId = isCircleLayer ? getCircleMapboxLayerId(mapboxLayerId) : mapboxLayerId;

  return `${HIGHLIGHT_LAYER_PREFIX}${layerId}`;
};
